import { Arrow } from "./ArrowControls.styles";

type ArrowControlProps = {
    next: () => void;
    nextAriaDisabled?: boolean;
    nextLabel: string;
    prev: () => void;
    prevAriaDisabled?: boolean;
    prevLabel: string;
};

export const ArrowControls = ({
    next,
    nextAriaDisabled = undefined,
    nextLabel,
    prev,
    prevAriaDisabled = undefined,
    prevLabel
}: ArrowControlProps) => {
    return (
        <>
            <Arrow
                aria-label={prevLabel}
                aria-disabled={prevAriaDisabled}
                data-testid="arrow_prev"
                onClick={prev}
            >
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <rect width="30" height="30" rx="15" />
                    <path
                        d="M16.7167 8.21674L10.2168 14.7167L16.5001 20.9999"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Arrow>
            <Arrow
                aria-label={nextLabel}
                aria-disabled={nextAriaDisabled}
                data-testid="arrow_next"
                onClick={next}
            >
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <rect
                        x="30"
                        y="30"
                        width="30"
                        height="30"
                        rx="15"
                        transform="rotate(-180 30 30)"
                    />
                    <path
                        d="M13.2833 21.7833L19.7832 15.2833L13.4999 9.00007"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Arrow>
        </>
    );
};
